import { useMutation } from "@tanstack/react-query";
import { fetchWithErrorHandling } from "../utils/service";

export const useAuthLogin = () =>
  useMutation({
    mutationFn: (credentials) =>
      fetchWithErrorHandling("/v1/auth/login", {
        method: "POST",
        body: JSON.stringify(credentials),
      }),
  });

export const useAuthRegister = () =>
  useMutation({
    mutationFn: (credentials) =>
      fetchWithErrorHandling("/v1/auth/register", {
        method: "POST",
        body: JSON.stringify(credentials),
      }),
  });

export const useAuthLogout = () =>
  useMutation({
    mutationFn: () =>
      fetchWithErrorHandling("/v1/auth/logout", {
        method: "POST",
      }),
  });

/**
 * Refresh JWT token to get updated user data including plan status
 * @returns {Promise<{token: string, account: Object}>}
 */
export const useRefreshToken = () =>
  useMutation({
    mutationFn: () =>
      fetchWithErrorHandling("/v1/auth/refresh", {
        method: "POST",
        skipAuthErrorHandling: true, // Don't trigger logout on auth errors during refresh
      }),
  });
